import { render } from "./DiscoverPage.vue?vue&type=template&id=113fa36e&scoped=true"
import script from "./DiscoverPage.vue?vue&type=script&lang=js"
export * from "./DiscoverPage.vue?vue&type=script&lang=js"

import "./DiscoverPage.vue?vue&type=style&index=0&id=113fa36e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-113fa36e"]])

export default __exports__